// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,\nbody {\n  height: 100%;\n}\n\n@media (min-width: 640px) {\n  table {\n    display: inline-table !important;\n  }\n\n  thead tr:not(:first-child) {\n    display: none;\n  }\n}\n\ntd:not(:last-child) {\n  border-bottom: 0;\n}\n\nth:not(:last-child) {\n  border-bottom: 2px solid rgba(0, 0, 0, .1);\n}", ""]);
// Exports
module.exports = exports;
